module.exports = __webpack_public_path__ + "static/GrayWladyslawowo-df627a87bb8f9bc69cfdd22d0a98bc29.svg";